import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {ActivatedRoute, Router, NavigationStart} from '@angular/router';
import {Lrahos} from './Lrahos';
// import { $ } from 'protractor';
import * as $ from 'jquery';
import {DomSanitizer} from '@angular/platform-browser';
import {Globals} from '../globals';
import {Route} from '@angular/compiler/src/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-lrahos',
  templateUrl: './lrahos.component.html',
  styleUrls: ['./lrahos.component.scss']
})
export class LrahosComponent implements OnInit {
  lrahos: Lrahos;
  page: any;
  date: any;
  somethingChanged: any;
  dataToSend: any;
  slider = new Array();
  selectedDateOn;
  config2: any = {
    //  effect:'fade',
    autoplay: true, // Autoplay option having value in milliseconds
    initialSlide: 0, // Slide Index Starting from 0
    slidesPerView: 1, // Slides Visible in Single View Default is 1
    spaceBetween: 50,
    paginationClickable: true, // Making pagination dots clicable
    // pagination: '.swiper-pagination', // Pagination Class defined
    breakpoints: {
      900: {
        slidesPerView: 1,
      },
      640: {
        slidesPerView: 1,
      }
    },

    speed: 1000,
    loop: false,

    zoomToggle: false,
    setWrapperSize: true,

  };
  selectedDateOff;
  config: any = {
    //  effect:'fade',
    autoplay: false, // Autoplay option having value in milliseconds
    initialSlide: 0, // Slide Index Starting from 0
    slidesPerView: 1, // Slides Visible in Single View Default is 1
    spaceBetween: 50,

    paginationClickable: true, // Making pagination dots clicable

    // pagination: '.swiper-pagination', // Pagination Class defined

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    speed: 1000,
    loop: true,

    zoomToggle: false,
    setWrapperSize: true,

  };
  p: any = 1;
  url;
  curent;
  collection: any[] = [];

  today: any;
  todays: any;

  constructor(private http: HttpClient, public router: Router, public _location: Location, public globals: Globals, private route: ActivatedRoute, public sanitizer: DomSanitizer) {
    var url_string = location.href;
    this.url = url_string;
    this.p = url_string.substr(url_string.lastIndexOf('=') + 1);


    this.router.events
      .subscribe((event: NavigationStart) => {
        if (event.navigationTrigger === 'popstate') {
          setTimeout(() => {
            location.reload();
          }, 200);
        }
      });
  }

  changeDateOn(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    this.selectedDateOn = target.value;
    this.changeReq();
    // alert(this.today)
  }

  changeDateOff(event) {
    var target = event.target || event.srcElement || event.currentTarget;
    this.selectedDateOff = target.value;
    this.changeReq();
    // alert(this.today)
  }


  ngOnInit() {


    $(window).scrollTop(0);

    this.today = new Date().toISOString().split('T')[0];
    this.changeReq();

  }


  dateChanged(val: any) {
    var num;
    // console.log('Date changed', val);
    this.somethingChanged = val.value.toString().split(' ');
    // console.log(this.somethingChanged);
    if (this.somethingChanged[1] == 'Jan') {
      num = '01';
    } else if (this.somethingChanged[1] == 'Feb') {
      num = '02';
    } else if (this.somethingChanged[1] == 'Mar') {
      num = '03';
    } else if (this.somethingChanged[1] == 'Apr') {
      num = '04';
    } else if (this.somethingChanged[1] == 'May') {
      num = '05';
    } else if (this.somethingChanged[1] == 'Jun') {
      num = '06';
    } else if (this.somethingChanged[1] == 'Jul') {
      num = '07';
    } else if (this.somethingChanged[1] == 'Aug') {
      num = '08';
    } else if (this.somethingChanged[1] == 'Sep') {
      num = '09';
    } else if (this.somethingChanged[1] == 'Oct') {
      num = '10';
    } else if (this.somethingChanged[1] == 'Nov') {
      num = '11';
    } else if (this.somethingChanged[1] == 'Dec') {
      num = '12';
    }
    this.dataToSend = this.somethingChanged[3] + '-' + num + '-' + this.somethingChanged[2];
    // console.log(this.dataToSend)
    this.http.get<Lrahos>(this.globals.urlMain + 'lrahos', {
      params: {
        data: this.dataToSend
      }

    }).subscribe(data => {
      this.lrahos = data;
      console.log('***************************************this.lrahos***********************************');
      console.log(this.lrahos);
      // this.changel()
      var k = Number(data.data.news.data.pagination.total);
      this.collection = [];
      for (let i = 0; i <= k; i++) {
        this.collection.push(i);
      }
    });
    $(window).scrollTop(0);
  }
  openModalaudio(event) {
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.itemContent').find('.title').text();
    var iframe = $(target).closest('.itemContent').find('img').attr('data-id');
    var audiosrc = $(target).closest('.itemContent').find('audio').attr('data-id');
    var newIframe = document.createElement('img');
    newIframe.src = iframe;
    newIframe.style.width = '100%';
    newIframe.style.objectFit = 'cover';
    // newIframe.allowFullscreen= true;
    // var audio = document.createElement('iframe');
    // audio.src= audiosrc;

    var oldaudio = document.createElement('audio');
    oldaudio.src = audiosrc;
    oldaudio.style.height = '30px';
    oldaudio.style.width = '92%';
    oldaudio.style.position = 'absolute';
    oldaudio.style.bottom = '30px';
    oldaudio.style.zIndex = '9';
    oldaudio.controls = true;
    // $(target).closest('.smallZinuj').remove();
    $('.modalDescription').html('').append(oldaudio);
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);

    // height: 30px;
    // width: 92%;
    // position: absolute;
    // margin-top: 58%;

  };

  locationReload(): void {

    setTimeout(() => {
      this.router.navigateByUrl('', {skipLocationChange: true}).then(() => {
        console.log(decodeURI(this._location.path()));
        this.router.navigate([decodeURI(this._location.path())]);
      });
    }, 200);
  }

  changel() {
    this.changeReq();
    this.router.navigate(['/home/lrahos'], {queryParams: {page: this.p}});
    var height = $('header').height();
    $(window).scrollTop(height);


  }

  changeReq() {

    this.http.get<Lrahos>(this.globals.urlMain + 'lrahos', {
      params: {
        page: this.p,

      }

    }).subscribe(data => {
      this.lrahos = data;
      console.log('***************************************this.lrahos***********************************');
      console.log(this.lrahos);
      this.slider.push(data.data);

      var k = Number(data.data.news.data.pagination.total);
      this.collection = [];
      for (let i = 0; i <= k; i++) {
        this.collection.push(i);
      }


    });


  }

  openModal(event) {
    $('.modalForVideos').addClass('shown');
    var target = event.target || event.srcElement || event.currentTarget;
    var title = $(target).closest('.itemContent').find('.title').text();
    var iframe = $(target).closest('.itemContent').find('img').attr('data-id');
    var newIframe = document.createElement('iframe');
    newIframe.src = iframe;
    newIframe.height = '100%';
    newIframe.width = '100%';
    newIframe.allowFullscreen = true;
    $('.modalTitle').html(title);
    $('.modileIframe').html(newIframe);

  }

  closeModal() {
    $('.modileIframe').html('');
    $('.modalDescription').html('');
    $('.modalForVideos').removeClass('shown');
  }
}
